import { render } from "./OrderReturnRelocateModal.vue?vue&type=template&id=5665b8d8&ts=true&lang=pug"
import script from "./OrderReturnRelocateModal.vue?vue&type=script&lang=ts"
export * from "./OrderReturnRelocateModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__